import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";

import Header from "../../../components/Headers/Header";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";

import { getEnrolledTeachers } from "../../../Services/Reports/ReportService";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { ArrowRight } from "react-bootstrap-icons";
import { ISelectedFilters } from "../../../types";
import Filter from "../Components/Filter/Filter";

export default function EnrolledTeachers() {
  const history = useHistory();

  const session = useSelector((state: any) => state.user.session);
  const [enrolledTeachers, setEnrolledTeachers] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchEnrolledTeachers = useCallback(
    (filters?: ISelectedFilters) => {
      setIsLoading(true);
      const districtId = filters?.districtId;
      const blockId = filters?.blockId;
      getEnrolledTeachers(
        districtId ? (blockId ? "school" : "block") : "district",
        session?.id,
        districtId,
        blockId
      )
        .then(
          (response: AxiosResponse) => {
            setEnrolledTeachers(response?.data?.data);
          },
          (error) => {
            console.log("Error caught: ", error?.response);
            toast.error(
              "Sorry! Could not generate report. Please try again later."
            );
          }
        )
        .finally(() => setIsLoading(false));
    },
    [session?.id]
  );
  useEffect(() => {
    fetchEnrolledTeachers();
  }, [fetchEnrolledTeachers]);

  return (
    <React.Fragment>
      <Header />

      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Enrolled Teachers
              </h3>
              <div>
                <div>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => history.push(STATE_OFFICIAL_PATHS.reports)}
                  >
                    Go Back <ArrowRight />
                  </Button>
                </div>
              </div>
            </div>

            {/* <div className="pt-2">
              <Filter
                hasDistrictFilter
                hasBlockFilter
                onSearch={(value) => {
                  fetchEnrolledTeachers(value);
                }}
                onClear={() => {
                  fetchEnrolledTeachers();
                }}
              />
            </div> */}
          </CardHeader>

          <CardBody>
            {!isLoading ? (
              <div className="d-flex flex-wrap">
                {enrolledTeachers?.length !== 0 ? (
                  enrolledTeachers?.map((each, index) => (
                    <Card
                      key={index}
                      className="mb-2 mr-2"
                      style={{ maxWidth: "45%" }}
                    >
                      <CardBody className="d-flex flex-column justify-content-start">
                        <div>
                          <h3>{each?.teachers_count}</h3>
                          <span className="text-muted small">
                            Teacher Strength
                          </span>
                        </div>
                        {each?.school ? (
                          <span>
                            <span className="font-weight-bold">School:</span>{" "}
                            {each?.school}
                          </span>
                        ) : each?.block ? (
                          <span>
                            <span className="font-weight-bold">Block:</span>{" "}
                            {each?.block}
                          </span>
                        ) : each?.district ? (
                          <span>
                            <span className="font-weight-bold">District:</span>{" "}
                            {each?.district}
                          </span>
                        ) : (
                          <></>
                        )}
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="w-100 d-flex justify-content-center">
                    No data available for selected filters!
                  </div>
                )}
              </div>
            ) : (
              <DotsSpinner />
            )}
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
